import { loginApi, type PostUserLoginAuthTokenPayload } from '@capsicum/common';

export async function fetchUserLoginAuthToken(params: PostUserLoginAuthTokenPayload) {
	const api = await loginApi;

	return api.postUserLoginAuthToken(params).then(res => res.data);
}
